const _compose = (f, g) => (...args) => g(f(...args));

export default (...fns) => fns.reduceRight(_compose);
